import QrScanner from 'qr-scanner';
import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import addNumberOff from '../../assets/camera/Add_number_desligado.svg';
import addNumberOn from '../../assets/camera/Add_number_ligado.svg';
import qrCodePhraseInfo from '../../assets/camera/icon_qrreader.svg';
import flashlightOff from '../../assets/camera/lanterna_desligada.svg';
import flashlightOn from '../../assets/camera/lanterna_ligada.svg';
import Button from '../../components/button/Button';
import ToastChargerUnavailable from '../../components/chargerStationCardList/ToastChargerUnavailable/ToastChargerUnavailable';
import ToastNoCredit from '../../components/chargerStationCardList/ToastNoCredit/ToastNoCredit';
import ToastStartCharging from '../../components/chargerStationCardList/ToastStartCharging/ToastStartCharging';
import { useAuth } from '../../context/AuthContext';
import { useBrandContext } from '../../context/BrandContext';
import { postStartCharging } from '../../services/chargerStationService';
import { getChargeId } from '../../services/qrCodeReaderService';
import './QrReader.css';
import Modal from '../../components/modal/Modal';
import { useCouponStore } from '../../hooks/useCouponStore';
import api from '../../axios/axiosConfig';

const QrReaderPage = () => {
  const [chargerNumber, setChargerNumber] = useState<string | null>(null);
  const [inputChargerNumber, setInputChargerNumber] = useState('');
  const [chargeId, setChargeId] = useState('');
  const [connectorId, setconnectorId] = useState('');
  const [camReaderCpcodeMode, setcamReaderCpcodeMode] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openModalChargerUnavailable, setOpenModalChargerUnavailable] =
    useState(false);
  const [openNoCreditModal, setOpenNoCreditModal] = useState(false);
  const [isChargeExist, setChargeExist] = useState(true);
  const navigate = useNavigate();
  const [isTorchOn, setTorchOn] = useState(false);
  const { cpcode } = useParams();
  const videoRef = useRef(null);
  const [qrCodeScanner, setQrCodeScanner] = useState<any>();
  const authContext = useAuth();
  const brandContext = useBrandContext();

  const [selectedVehicle, setSelectedVehicle] = useState<string>();
  const { selectedCoupon, setSelectedCoupon } = useCouponStore();
  const { setCouponData } = useCouponStore();

  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
  const [titleErrorModal, setTitleErrorModal] = useState<string>('');
  const [textErrorModal, setTextErrorModal] = useState<string>('');

  const [cpCsId, setCpCsId] = useState<string | null>(null);

  function checkCameraPermission(): boolean {
    console.log('Check camera permission');

    try {
      navigator.permissions
        .query({ name: 'camera' as PermissionName })
        .then((result) => {
          if (result.state === 'denied') {
            console.error('Camera permission has been denied');
            return false;
          }
        })
        .catch((error) => {
          console.error('Error checking camera permissions:', error);
          return false;
        });
    } catch {}
    return true;
  }

  useEffect(() => {
    if (!authContext.isLogged()) {
      navigate(`/${brandContext.brandName}/login`);
      return;
    }

    checkCameraPermission();
    startCamera();
  }, []);

  function startCamera() {
    if (!qrCodeScanner) {
      try {
        initQrScanner();
      } catch (error) {
        console.error('Acesso à câmera negado pelo usuário ou erro:', error);
      }
    }
  }

  async function stopCamera() {
    if (qrCodeScanner) {
      qrCodeScanner.stop();
      qrCodeScanner.destroy();
      setQrCodeScanner(null);
      setcamReaderCpcodeMode(false);
    }
  }

  function initQrScanner() {
    let qrScanner;
    if (!qrCodeScanner && videoRef?.current) {
      qrScanner = new QrScanner(
        videoRef.current,
        (result) => {
          if (result?.data && !chargerNumber && camReaderCpcodeMode) {
            const chargeNumb = formatChargeNumber(result?.data);
            setChargerNumber(chargeNumb);
          }
        },
        {
          preferredCamera: 'environment',
          highlightCodeOutline: true,
          highlightScanRegion: false,
          maxScansPerSecond: 2,
        }
      );
      qrScanner.start().catch((err) => {});
    }

    setQrCodeScanner(qrScanner);
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;
    value = formatInput(value);
    if (value.length <= 7) {
      setInputChargerNumber(value);
    }
  };

  function formatChargeNumber(chargeNumberUrl: string) {
    const splitChargeNumber = chargeNumberUrl.split('/');
    const chargeNumber = splitChargeNumber[splitChargeNumber.length - 1];
    return chargeNumber;
  }

  function isValidChagerNumber(code: string): boolean {
    const pattern = /^\d{5}-\d$/;
    return pattern.test(code);
  }

  const formatInput = (value: any) => {
    const numbers = value.replace(/\D/g, '');

    const firstPart = numbers.substring(0, 5);
    const secondPart = numbers.substring(5, 6);

    let formattedValue = firstPart;
    if (secondPart) {
      formattedValue += `-${secondPart}`;
    }

    return formattedValue;
  };

  const handleSubmit = async () => {
    if (inputChargerNumber !== '' && isValidChagerNumber(inputChargerNumber)) {
      setChargerNumber(inputChargerNumber);
    }
  };

  const getOnlineConnectorStatus = async (cpcode: string) => {
    setCpCsId(null);
    try {
      const response = await api.get(`/OnlineConnectorStatus/${cpcode}`);
      setCpCsId(response.data[0].siteId);
    } catch (error: any) {
      console.error(error);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 250);
    }
  };

  const extractChargePointParts = (value: string) => {
    const separatorIndex = value.lastIndexOf('-');
    if (separatorIndex === -1) {
      throw new Error('Charge point identifier is missing connector separator');
    }

    const chargePointId = value.slice(0, separatorIndex);
    const connector = value.slice(separatorIndex + 1);

    if (!chargePointId || !connector) {
      throw new Error('Charge point identifier is incomplete');
    }

    return { chargePointId, connector };
  };

  const getChargerIdNumber = async (chargerNumber: string) => {
    try {
      const { chargePointId: cpcodeId, connector } =
        extractChargePointParts(chargerNumber);
      const connectorId = parseInt(connector, 10);
      if (Number.isNaN(connectorId)) {
        throw new Error('Connector identifier is not numeric');
      }
      const chargerIdPlusConnectorId = await getChargeId(cpcodeId, connectorId);
      if (chargerIdPlusConnectorId.chargerId === 'Not Found') {
        setChargeExist(false);
        setcamReaderCpcodeMode(false);
        clearChargeNumbers();
      } else {
        const {
          chargePointId: resolvedChargeId,
          connector: resolvedConnectorId,
        } = extractChargePointParts(chargerIdPlusConnectorId.chargerId);
        setChargeId(resolvedChargeId);
        setconnectorId(resolvedConnectorId);
        getOnlineConnectorStatus(chargerIdPlusConnectorId.chargerId);
        setOpenModal(true);
      }
    } catch (error: any) {
      clearChargeNumbers();
      console.error('Erro ao consultar informações recarga', error);
    }
  };

  useEffect(() => {
    if (chargerNumber) {
      console.log('chargerNumber: ' + chargerNumber);
      getChargerIdNumber(chargerNumber);
    }
  }, [chargerNumber]);

  useEffect(() => {
    if (cpcode && authContext.isLogged()) {
      console.log('CpCode parameter:', cpcode);
      setcamReaderCpcodeMode(true);

      setTimeout(() => {
        setChargerNumber(formatChargeNumber(cpcode));
      }, 100);
    }
  }, [cpcode]);

  useEffect(() => {
    if (!openModal) {
      clearChargeNumbers();
    }
  }, [openModal]);

  const clearChargeNumbers = () => {
    setChargerNumber(null);
    setInputChargerNumber('');
  };

  const clearAll = () => {
    setChargeId('');
    setconnectorId('');
    clearChargeNumbers();
    setChargeExist(true);
  };

  const closeModalBtn = () => {
    setChargeId('');
    setconnectorId('');
    clearChargeNumbers();
    setChargeExist(true);
    setcamReaderCpcodeMode(true);
  };

  const startCharging = async () => {
    setIsLoading(true);
    try {
      const response = await postStartCharging(
        chargeId,
        connectorId,
        selectedVehicle,
        selectedCoupon && selectedCoupon.trim() !== '' ? selectedCoupon : null
      );
      if (response.status === 'Error') {
        setTitleErrorModal('Erro ao utilizar o cupom');
        setTextErrorModal(response.info);
        setShowErrorModal(true);
        setIsLoading(false);
        setSelectedCoupon(null);
        setCouponData({});
        return;
      }
      if (response.status === 'Accepted') {
        await stopCamera();
        handleInfoChargePage();
        setIsLoading(false);
        setOpenModalChargerUnavailable(false);
        setOpenModal(false);
        setOpenNoCreditModal(false);
      } else if (
        response.status === 'Rejected' &&
        response.info === 'ERR_WALLET_LOW_BALANCE'
      ) {
        setOpenModal(false);
        setOpenModalChargerUnavailable(false);
        setIsLoading(false);
        setOpenNoCreditModal(true);
        setSelectedCoupon(null);
        setCouponData({});
      } else if (response.status === 'TimedOut') {
        setOpenModal(false);
        setOpenModalChargerUnavailable(true);
        setIsLoading(false);
        setOpenNoCreditModal(false);
        setSelectedCoupon(null);
        setCouponData({});
      } else {
        setOpenModal(false);
        setOpenModalChargerUnavailable(true);
        setIsLoading(false);
        setOpenNoCreditModal(false);
        setSelectedCoupon(null);
        setCouponData({});
      }
    } catch (error) {
      setIsLoading(false);
      console.error('Erro ao iniciar recarga', error);
    }
  };

  const changeCpcodeCapture = () => {
    setcamReaderCpcodeMode(!camReaderCpcodeMode);
  };

  const getAddnumberImage = () => {
    return camReaderCpcodeMode ? addNumberOn : addNumberOff;
  };

  const getFlashlightImage = () => {
    return isTorchOn ? flashlightOff : flashlightOn;
  };

  const getBtnIntName = () => {
    return isChargeExist ? 'Iniciar recarga' : 'Entendi';
  };

  const getTitle = () => {
    return isChargeExist
      ? 'Insira o número do carregador'
      : 'O número parece incorreto';
  };

  const handleInfoChargePage = () => {
    navigate(`/${brandContext.brandName}/recharge/${chargeId}/${connectorId}`);
  };

  const closeQrReader = async () => {
    clearChargeNumbers();
    await stopCamera();
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(`/${brandContext.brandName}/`);
    }
  };

  const handleCloseToastChargerUnavailable = () => {
    setOpenModalChargerUnavailable(false);
  };

  const toggleFlash = () => {
    qrCodeScanner
      .hasFlash()
      .then((hasFlash: any) => {
        if (hasFlash) {
          qrCodeScanner
            .toggleFlash()
            .then(() => {
              setTorchOn(!isTorchOn);
            })
            .catch((error: any) => {
              console.error('Erro ao alternar a lanterna:', error);
            });
        }
      })
      .catch((error: any) => {
        console.error('Erro ao verificar suporte de flash:', error);
      });
  };

  return (
    <>
      {
        <div className='qrcode-screen'>
          <div className='explain-infos'>
            <img className='qrCodeInfos-img' src={qrCodePhraseInfo} />
            <div className='qrCodeInfos-text'>
              Aponte para o QR code para iniciar a recarga
            </div>
          </div>
          <div className='black-backgroung'>
            {camReaderCpcodeMode ? (
              <div className='highlight-overlay'></div>
            ) : (
              <div>
                <div className='bg-full-overlay'></div>
                <div className='charger-number-overlay'>
                  <div className='charger-number-form'>
                    <div className='close-modal-button'>
                      <button
                        onClick={closeModalBtn}
                        type='button'
                        className='close-modal-button_btn'
                      >
                        X
                      </button>
                    </div>
                    <span className='charger-number-label'>{getTitle()}</span>
                    {isChargeExist ? (
                      <input
                        type='text'
                        id='charger-number'
                        value={inputChargerNumber}
                        onChange={(e) => handleChange(e)}
                        className='charger-number-input'
                        inputMode='numeric'
                        pattern='\d{5}-\d{1}'
                      />
                    ) : (
                      <span className='charger-number-label-subtitle'>
                        Digite outra vez ou confira sua conexão de internet.
                      </span>
                    )}
                  </div>
                </div>
                {isChargeExist ? (
                  <button
                    type='submit'
                    className='submit-button'
                    onClick={handleSubmit}
                  >
                    {getBtnIntName()}
                  </button>
                ) : (
                  <button className='submit-button' onClick={clearAll}>
                    {getBtnIntName()}
                  </button>
                )}
              </div>
            )}
          </div>
          <div className='task-buttons'>
            <div
              className='flashlight task-buttons_comon'
              onClick={() => toggleFlash()}
            >
              <img src={getFlashlightImage()} />
              <span>Ligar Lanterna</span>
              <br />
            </div>
            <div
              className='addNumber task-buttons_comon'
              onClick={changeCpcodeCapture}
            >
              <img src={getAddnumberImage()} />
              <span>Insira o número do carregador</span>
            </div>
          </div>
          <div className='close-button'>
            <Button
              style={{
                backgroundColor: 'transparent',
                color: '#FFF',
                border: '1px solid var(--Neutral-Regular, #787E7D)',
                width: '317px',
              }}
              type='button'
              children='Fechar'
              onClick={closeQrReader}
            />
          </div>
        </div>
      }
      <video className='camera' id='qr-reader' ref={videoRef} />
      <ToastStartCharging
        setIsLoading={setIsLoading}
        isLoading={isLoading}
        allowButtonClosed={true}
        handleStartCharging={startCharging}
        isModalOpen={openModal}
        setIsModalOpen={setOpenModal}
        chargerId={chargeId}
        chargerSiteId={cpCsId}
        setSelectedVehicle={setSelectedVehicle}
        selectedVehicle={selectedVehicle}
      />
      <ToastNoCredit
        isLoading={isLoading}
        allowButtonClosed={true}
        handleClick={() => navigate(`/${brandContext.brandName}/paymentMethods`)}
        isModalOpen={openNoCreditModal}
        setIsModalOpen={setOpenNoCreditModal}
      />
      <ToastChargerUnavailable
        onClose={() => handleCloseToastChargerUnavailable()}
        isLoading={isLoading}
        allowButtonClosed={true}
        handleStartCharging={startCharging}
        isModalOpen={openModalChargerUnavailable}
        setIsModalOpen={setOpenModalChargerUnavailable}
      />
      <Modal
        allowButtonClosed={true}
        isOpen={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        title={titleErrorModal}
        styleEnterButton={{
          backgroundColor: 'rgb(173, 173, 173)',
          border: 'none',
        }}
        textEnterButton='Fechar'
        handleEnterButton={() => setShowErrorModal(false)}
        isLoadingEnterButton={isLoading}
      >
        <p>{textErrorModal}</p>
      </Modal>
    </>
  );
};

export default QrReaderPage;
